function ImagesJunior(){
    return(
        <div className="w-full h-full">
            <div className="grid grid-cols-1 gap-6">

            <img src='https://fireart.studio/wp-content/themes/fireart/assets/img/wideimg/01.webp'
             className="w-full h-70 object-cover"/>
            
            </div>
        </div>
    )
}
export default ImagesJunior